import { useEffect } from "react";

const SITE = "https://fnbinternational.com";

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

const setCanonical = (href) => {
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
};

export const Seo = ({ title, description, path = "/", robots }) => {
    useEffect(() => {
        document.title = title;
        if (description) {
            setMeta("name", "description", description);
            setMeta("property", "og:title", title);
            setMeta("property", "og:description", description);
            setMeta("name", "twitter:title", title);
            setMeta("name", "twitter:description", description);
        }
        setCanonical(`${SITE}${path}`);
        setMeta("property", "og:url", `${SITE}${path}`);
        if (robots) setMeta("name", "robots", robots);
        else setMeta("name", "robots", "index, follow, max-image-preview:large, max-snippet:-1");
    }, [title, description, path, robots]);
    return null;
};
